import React, { useState, useEffect } from "react";
import MultiSelectListBox from "./multiselectlistbox/index";

const GralMultiSelectListBox = (props) => {
  const [selectedTwo, setSelectedTwo] = useState(props.initialselectedids);
  const loadmode = props.loadmode; // loadmode = true when creating and loadmode = false when updating

  useEffect(() => {
    console.log("xtr");
    setSelectedTwo(props.initialselectedids);
  },loadmode?[]:[props.initialselectedids]); // this is needed as second argument for Edit [props.initialselectedids]!

  useEffect(() => {
    props.selValue(selectedTwo);        
  }, [selectedTwo]);

  return (
    <div className="container">
      <MultiSelectListBox
        className={"multi-select"}
        overrideStrings={{
          search: "Search...",
          selectAll: "Add All",
          removeAll: "Remove All",
          selectedInfo: "Records selected"
        }}
        sortable={true}
        alloptions={getOptions(descAndID(props.alloptions,props.descField,props.idField))}
        textField="desc"
        valueField="value"
        value={selectedTwo}
        rowHeight={30}
        onSelect={({ item, sortedList }) => {          
          setSelectedTwo(sortedList.map(i => i.value));
          console.log(selectedTwo);          
        }}
        onRemove={({ item }) => {
          setSelectedTwo([...selectedTwo.filter(i => i !== item.value)]);
        }}
        onSelectAll={selectedItems => {
          const selected = [
            ...selectedTwo,
            ...selectedItems.map(item => item.value)
          ];
          setSelectedTwo(selected);
        }}
        onRemoveAll={() => setSelectedTwo([])}
        onSort={({ sortedList }) =>
          setSelectedTwo([...sortedList.map(i => i.value)])
        }
      />
    </div>
  );
};

let extractColumn = (arr, column) => arr.map(x=>x[column]);

let descAndID = (arr, desc, id) => {
  return [[extractColumn(arr, id)],[extractColumn(arr, desc)]]
}

// Expected array of arrays
const getOptions = records => {  
  let options = [];
  //console.log(records[0][0].length);
  //console.log(records[1][0][4]);
  for (let i = 0; i < records[0][0].length; i++) {
  //  console.log(records[1][0][i]);
    options.push({
      desc: records[1][0][i],
      value: records[0][0][i]
    });
  }  
  return options;
};
export default GralMultiSelectListBox;
